import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const AgeBracketCard = ({ bracket, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, delay: index * 0.05 }}
    >
      <Link to={`/health/by-age/${bracket.slug}`} className="health-age-card">
        <div className="health-age-card-title">{bracket.title}</div>
        <div className="health-age-card-summary">{bracket.summary}</div>
      </Link>
    </motion.div>
  );
};

export default AgeBracketCard;
